export const sharedFacets = [
  {
    __typename: 'SimpleFacet',
    facetName: 'en_productCategory_content',
    facetHeader: 'Product Category',
    options: [
      {
        optionName: 'Clothing',
        displayName: 'Clothing',
        matchedProductCount: 371,
        __typename: 'SimpleFacetOption',
      },
    ],
  },
  {
    __typename: 'SimpleFacet',
    facetName: 'en_protein_content',
    facetHeader: 'Protein',
    options: [],
  },
  {
    __typename: 'SimpleFacet',
    facetName: 'en_tabletsAndCapsules_content',
    facetHeader: 'Tablets and Capsules',
    options: [],
  },
  {
    __typename: 'SimpleFacet',
    facetName: 'en_gender_content',
    facetHeader: 'Gender',
    options: [
      {
        optionName: 'Men',
        displayName: 'Men',
        matchedProductCount: 194,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'Women',
        displayName: 'Women',
        matchedProductCount: 177,
        __typename: 'SimpleFacetOption',
      },
    ],
  },
  {
    __typename: 'SimpleFacet',
    facetName: 'en_sportsClothingtype_content',
    facetHeader: 'Sport Clothing',
    options: [
      {
        optionName: 'Baselayer',
        displayName: 'Baselayer',
        matchedProductCount: 5,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'Crop Top',
        displayName: 'Crop Top',
        matchedProductCount: 30,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'Sports Bras',
        displayName: 'Sports Bras',
        matchedProductCount: 3,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'Tank Top',
        displayName: 'Tank Top',
        matchedProductCount: 2,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'T-Shirt',
        displayName: 'T-Shirt',
        matchedProductCount: 328,
        __typename: 'SimpleFacetOption',
      },
    ],
  },
  {
    __typename: 'SimpleFacet',
    facetName: 'en_myprotein_clothingSize_content',
    facetHeader: 'Clothing Size',
    options: [
      {
        optionName: 'XXS',
        displayName: 'XXS',
        matchedProductCount: 307,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'XS',
        displayName: 'XS',
        matchedProductCount: 336,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'S',
        displayName: 'S',
        matchedProductCount: 327,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'M',
        displayName: 'M',
        matchedProductCount: 314,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'L',
        displayName: 'L',
        matchedProductCount: 279,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'XL',
        displayName: 'XL',
        matchedProductCount: 257,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'XXL',
        displayName: 'XXL',
        matchedProductCount: 239,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'XXXL',
        displayName: 'XXXL',
        matchedProductCount: 147,
        __typename: 'SimpleFacetOption',
      },
    ],
  },
  {
    __typename: 'SimpleFacet',
    facetName: 'en_nutritionProducttype_content',
    facetHeader: 'Nutrition Product Type',
    options: [],
  },
  {
    __typename: 'SimpleFacet',
    facetName: 'en_nutritionAccessories_content',
    facetHeader: 'Nutrition Accessories',
    options: [],
  },
  {
    __typename: 'SimpleFacet',
    facetName: 'en_packageComposition_content',
    facetHeader: 'Package Composition',
    options: [],
  },
  {
    __typename: 'SimpleFacet',
    facetName: 'en_Diet_content',
    facetHeader: 'Diet',
    options: [],
  },
  {
    __typename: 'SimpleFacet',
    facetName: 'en_myprotein_volume_content',
    facetHeader: 'Volume',
    options: [],
  },
  {
    __typename: 'SimpleFacet',
    facetName: 'en_myprotein_flavour_content',
    facetHeader: 'Flavour',
    options: [],
  },
  {
    __typename: 'SimpleFacet',
    facetName: 'en_myprotein_ColourRange_content',
    facetHeader: 'Colour Range',
    options: [
      {
        optionName: 'Black',
        displayName: 'Black',
        matchedProductCount: 81,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'Blue',
        displayName: 'Blue',
        matchedProductCount: 88,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'Brown',
        displayName: 'Brown',
        matchedProductCount: 2,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'Cream',
        displayName: 'Cream',
        matchedProductCount: 1,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'Green',
        displayName: 'Green',
        matchedProductCount: 48,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'Grey',
        displayName: 'Grey',
        matchedProductCount: 30,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'Pink',
        displayName: 'Pink',
        matchedProductCount: 42,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'Purple',
        displayName: 'Purple',
        matchedProductCount: 10,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'Red',
        displayName: 'Red',
        matchedProductCount: 39,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'White',
        displayName: 'White',
        matchedProductCount: 38,
        __typename: 'SimpleFacetOption',
      },
      {
        optionName: 'Yellow',
        displayName: 'Yellow',
        matchedProductCount: 2,
        __typename: 'SimpleFacetOption',
      },
    ],
  },
  {
    __typename: 'RangedFacet',
    facetName: 'myprotein_GBP_price',
    facetHeader: 'Price',
    options: [
      {
        displayName: 'Less than £10',
        from: null,
        to: 10,
        matchedProductCount: 44,
        __typename: 'RangedFacetOption',
      },
      {
        displayName: '£10 - £25',
        from: 10,
        to: 25,
        matchedProductCount: 283,
        __typename: 'RangedFacetOption',
      },
      {
        displayName: '£25 - £50',
        from: 25,
        to: 50,
        matchedProductCount: 46,
        __typename: 'RangedFacetOption',
      },
      {
        displayName: '£50 - £100',
        from: 50,
        to: 100,
        matchedProductCount: 0,
        __typename: 'RangedFacetOption',
      },
      {
        displayName: 'More than £100',
        from: 100,
        to: null,
        matchedProductCount: 0,
        __typename: 'RangedFacetOption',
      },
    ],
  },
  {
    __typename: 'RangedFacet',
    facetName: 'myprotein_GBP_saving_percent',
    facetHeader: 'Savings',
    options: [
      {
        displayName: 'Up to 25%',
        from: 0.0001,
        to: 0.2499,
        matchedProductCount: 26,
        __typename: 'RangedFacetOption',
      },
      {
        displayName: '25% - 50%',
        from: 0.25,
        to: 0.4999,
        matchedProductCount: 117,
        __typename: 'RangedFacetOption',
      },
      {
        displayName: '50% - 75%',
        from: 0.5,
        to: 0.7499,
        matchedProductCount: 84,
        __typename: 'RangedFacetOption',
      },
      {
        displayName: 'More than 75%',
        from: 0.75,
        to: null,
        matchedProductCount: 2,
        __typename: 'RangedFacetOption',
      },
    ],
  },
]
const sharedProductOptions = [
  {
    __typename: 'VariantOption',
    key: 'Colour',
    choices: [
      {
        __typename: 'OptionChoice',
        optionKey: 'Colour',
        key: 'Black',
        colour: '#2D2C2F',
        title: 'Black',
      },
      {
        __typename: 'OptionChoice',
        optionKey: 'Colour',
        key: 'Mint',
        colour: '#9BC4AF',
        title: 'Mint',
      },
      {
        __typename: 'OptionChoice',
        optionKey: 'Colour',
        key: 'Poseidon',
        colour: '#133955',
        title: 'Poseidon',
      },
      {
        __typename: 'OptionChoice',
        optionKey: 'Colour',
        key: 'White',
        colour: '#F1F2F1',
        title: 'White',
      },
    ],
  },
]
const sharedColourVariants = [
  {
    __typename: 'ProductVariant',
    inStock: true,
    product: {
      __typename: 'Product',
      url:
        '/sports-clothing/mp-men-s-velocity-short-sleeve-t-shirt-poseidon/13111305.html',
    },
    choices: [
      {
        __typename: 'OptionChoice',
        optionKey: 'Size',
        key: 'XXS',
      },
      {
        __typename: 'OptionChoice',
        optionKey: 'Colour',
        key: 'Poseidon',
      },
    ],
  },
  {
    __typename: 'ProductVariant',
    inStock: true,
    product: {
      __typename: 'Product',
      url:
        '/sports-clothing/mp-men-s-velocity-short-sleeve-t-shirt-mint/13111296.html',
    },
    choices: [
      {
        __typename: 'OptionChoice',
        optionKey: 'Size',
        key: 'XS',
      },
      {
        __typename: 'OptionChoice',
        optionKey: 'Colour',
        key: 'Mint',
      },
    ],
  },
  {
    __typename: 'ProductVariant',
    inStock: true,
    product: {
      __typename: 'Product',
      url:
        '/sports-clothing/mp-men-s-velocity-short-sleeve-t-shirt-white/13111314.html',
    },
    choices: [
      {
        __typename: 'OptionChoice',
        optionKey: 'Size',
        key: 'L',
      },
      {
        __typename: 'OptionChoice',
        optionKey: 'Colour',
        key: 'White',
      },
    ],
  },
  {
    __typename: 'ProductVariant',
    inStock: true,
    product: {
      __typename: 'Product',
      url:
        '/sports-clothing/mp-men-s-velocity-short-sleeve-t-shirt-black/13111287.html',
    },
    choices: [
      {
        __typename: 'OptionChoice',
        optionKey: 'Size',
        key: 'XXS',
      },
      {
        __typename: 'OptionChoice',
        optionKey: 'Colour',
        key: 'Black',
      },
    ],
  },
]
const sharedMarketedSpecialOffer = {
  __typename: 'ProductMarketedSpecialOffer',
  title: {
    __typename: 'RichContent',
    content: [
      {
        __typename: 'RichContentItem',
        content: 'Complimentary Gift',
      },
    ],
  },
  description: {
    __typename: 'RichContent',
    content: [
      {
        __typename: 'RichContentItem',
        content:
          'Receive a complimentary Active Life Essentials when you spend £85. PLUS receive a Hydro Masque full size when you spend £125. Complimentary gift will be awarded at the basket. Offer valid for a limited time only, while stocks last. *Offer threshold is applicable after discount.',
      },
    ],
  },
  landingPageLink: {
    __typename: 'Hyperlink',
    text: 'SHOP NOW',
    url: '/health-beauty/dermalogica/all-dermalogica.list',
    openExternally: false,
    noFollow: false,
  },
  freeGiftProduct: {
    __typename: 'ProductVariant',
    sku: 13166119,
    images: [
      {
        __typename: 'ProductImage',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/13166119-9734872031927173.jpg',
      },
    ],
    title: 'Dermalogica Active Skin Essentials',
    price: {
      __typename: 'ProductPrice',
      rrp: {
        __typename: 'MoneyValue',
        displayValue: '£18.00',
      },
    },
  },
}

export const productListMock1 = [
  {
    __typename: 'Product',
    sku: 13111287,
    url:
      '/sports-clothing/mp-men-s-velocity-short-sleeve-t-shirt-black/13111287.html',
    title: "MP Men's Velocity Short Sleeve T-Shirt - Black",
    reviews: {
      __typename: 'ProductReviews',
      total: 0,
      averageScore: 0,
    },
    images: [
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/13111287-1224909887458763.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/13111287-1224909887458763.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/13111287-1224909887458763.jpg',
      },
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/13111287-1964909887503022.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/13111287-1964909887503022.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/13111287-1964909887503022.jpg',
      },
    ],
    defaultVariant: {
      inStock: true,
      __typename: 'ProductVariant',
    },
    inWishlist: false,
    options: sharedProductOptions,
    variants: sharedColourVariants,
    marketedSpecialOffer: sharedMarketedSpecialOffer,
  },
  {
    __typename: 'Product',
    sku: 13111314,
    url:
      '/sports-clothing/mp-men-s-velocity-short-sleeve-t-shirt-white/13111314.html',
    title: "MP Men's Velocity Short Sleeve T-Shirt - White",
    reviews: {
      __typename: 'ProductReviews',
      total: 0,
      averageScore: 0,
    },
    images: [
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/13111314-1104909887976668.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/13111314-1104909887976668.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/13111314-1104909887976668.jpg',
      },
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/13111314-1644909888021140.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/13111314-1644909888021140.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/13111314-1644909888021140.jpg',
      },
    ],
    defaultVariant: {
      inStock: true,
      __typename: 'ProductVariant',
    },
    inWishlist: false,
    options: sharedProductOptions,
    variants: sharedColourVariants,
    marketedSpecialOffer: sharedMarketedSpecialOffer,
  },
  {
    __typename: 'Product',
    sku: 12459542,
    url:
      '/sports-t-shirts/mp-men-s-performance-short-sleeve-t-shirt-black-carbon/12459542.html',
    title: "MP Men's Performance Short Sleeve T-Shirt - Black/Carbon",
    reviews: {
      __typename: 'ProductReviews',
      total: 24,
      averageScore: 4.79,
    },
    images: [
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12459542-1854906041274098.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12459542-1854906041274098.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12459542-1854906041274098.jpg',
      },
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12459542-1784906041350214.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12459542-1784906041350214.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12459542-1784906041350214.jpg',
      },
    ],
    defaultVariant: {
      inStock: true,
      __typename: 'ProductVariant',
    },
    inWishlist: false,
    options: sharedProductOptions,
    variants: sharedColourVariants,
    marketedSpecialOffer: sharedMarketedSpecialOffer,
  },
  {
    __typename: 'Product',
    sku: 12762102,
    url:
      '/sports-t-shirts/mp-men-s-composure-short-sleeve-t-shirt-black/12762102.html',
    title: "MP Men's Composure Short Sleeve T-Shirt - Black",
    reviews: {
      __typename: 'ProductReviews',
      total: 3,
      averageScore: 5,
    },
    images: [
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12762102-2964882192144185.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12762102-2964882192144185.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12762102-2964882192144185.jpg',
      },
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12762102-1164882192186287.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12762102-1164882192186287.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12762102-1164882192186287.jpg',
      },
    ],
    defaultVariant: {
      inStock: true,
      __typename: 'ProductVariant',
    },
    inWishlist: false,
    options: sharedProductOptions,
    variants: sharedColourVariants,
    marketedSpecialOffer: sharedMarketedSpecialOffer,
  },
  {
    __typename: 'Product',
    sku: 12768255,
    url:
      '/sports-t-shirts/mp-men-s-graphic-running-short-sleeve-t-shirt-black/12768255.html',
    title: "MP Men's Graphic Running Short Sleeve T-Shirt - Black",
    reviews: {
      __typename: 'ProductReviews',
      total: 1,
      averageScore: 5,
    },
    images: [
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12768255-7184862505529320.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12768255-7184862505529320.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12768255-7184862505529320.jpg',
      },
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12768255-1984862505589674.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12768255-1984862505589674.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12768255-1984862505589674.jpg',
      },
    ],
    defaultVariant: {
      inStock: true,
      __typename: 'ProductVariant',
    },
    inWishlist: false,
    options: sharedProductOptions,
    variants: sharedColourVariants,
    marketedSpecialOffer: sharedMarketedSpecialOffer,
  },
]

export const productListMock2 = [
  {
    __typename: 'Product',
    sku: 11869941,
    url:
      '/sports-t-shirts/mp-men-s-performance-t-shirt-chrome-marl/11869941.html',
    title: "MP Men's Performance T-shirt - Chrome Marl",
    reviews: {
      __typename: 'ProductReviews',
      total: 17,
      averageScore: 4.71,
    },
    images: [
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/11871718-7824659517818129.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/11871718-7824659517818129.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/11871718-7824659517818129.jpg',
      },
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/11871718-7644659517863231.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/11871718-7644659517863231.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/11871718-7644659517863231.jpg',
      },
    ],
    defaultVariant: {
      inStock: true,
      __typename: 'ProductVariant',
    },
    inWishlist: false,
    options: sharedProductOptions,
    variants: sharedColourVariants,
    marketedSpecialOffer: sharedMarketedSpecialOffer,
  },
  {
    __typename: 'Product',
    sku: 12774379,
    url:
      '/sports-t-shirts/mp-women-s-essentials-crop-t-shirt-light-pink/12774379.html',
    title: "MP Women's Essentials Crop T-Shirt - Light Pink",
    reviews: {
      __typename: 'ProductReviews',
      total: 1,
      averageScore: 5,
    },
    images: [
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12774379-7434865877072789.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12774379-7434865877072789.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12774379-7434865877072789.jpg',
      },
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12774379-1074865877111075.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12774379-1074865877111075.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12774379-1074865877111075.jpg',
      },
    ],
    defaultVariant: {
      inStock: true,
      __typename: 'ProductVariant',
    },
    inWishlist: false,
    options: sharedProductOptions,
    variants: sharedColourVariants,
    marketedSpecialOffer: sharedMarketedSpecialOffer,
  },
  {
    __typename: 'Product',
    sku: 12402109,
    url:
      '/sports-t-shirts/mp-women-s-essentials-crop-t-shirt-black/12402109.html',
    title: "MP Women's Essentials Crop T-Shirt - Black",
    reviews: {
      __typename: 'ProductReviews',
      total: 2,
      averageScore: 4,
    },
    images: [
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12402109-6754807998307509.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12402109-6754807998307509.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12402109-6754807998307509.jpg',
      },
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12402109-1854807998355044.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12402109-1854807998355044.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12402109-1854807998355044.jpg',
      },
    ],
    defaultVariant: {
      inStock: true,
      __typename: 'ProductVariant',
    },
    inWishlist: false,
    options: sharedProductOptions,
    variants: sharedColourVariants,
    marketedSpecialOffer: sharedMarketedSpecialOffer,
  },
  {
    __typename: 'Product',
    sku: 12763353,
    url:
      '/sports-t-shirts/mp-men-s-training-short-sleeve-t-shirt-storm/12763353.html',
    title: "MP Men's Training Short Sleeve T-Shirt - Storm",
    reviews: {
      __typename: 'ProductReviews',
      total: 1,
      averageScore: 5,
    },
    images: [
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12763353-8394864234290963.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12763353-8394864234290963.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12763353-8394864234290963.jpg',
      },
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12763353-1974864234331067.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12763353-1974864234331067.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12763353-1974864234331067.jpg',
      },
    ],
    defaultVariant: {
      inStock: true,
      __typename: 'ProductVariant',
    },
    inWishlist: false,
    options: sharedProductOptions,
    variants: sharedColourVariants,
    marketedSpecialOffer: sharedMarketedSpecialOffer,
  },
  {
    __typename: 'Product',
    sku: 12846890,
    url:
      '/sports-t-shirts/mp-women-s-fade-graphic-crop-t-shirt-black/12846890.html',
    title: "MP Women's Fade Graphic Crop T-Shirt - Black",
    reviews: {
      __typename: 'ProductReviews',
      total: 0,
      averageScore: 0,
    },
    images: [
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12846890-4474936389219939.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12846890-4474936389219939.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12846890-4474936389219939.jpg',
      },
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12846890-1074936389265212.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12846890-1074936389265212.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12846890-1074936389265212.jpg',
      },
    ],
    defaultVariant: {
      inStock: true,
      __typename: 'ProductVariant',
    },
    inWishlist: false,
    options: sharedProductOptions,
    variants: sharedColourVariants,
    marketedSpecialOffer: sharedMarketedSpecialOffer,
  },
]

export const productListAlphabeticalSortMock = [
  {
    __typename: 'Product',
    sku: 13053128,
    url: '/sports-clothing/benu-men-s-short-sleeve-t-shirt-blue/13053128.html',
    title: "BeNu Men's Short Sleeve T-Shirt - Blue",
    reviews: {
      __typename: 'ProductReviews',
      total: 0,
      averageScore: 0,
    },
    images: [
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/13053128-1834882202797629.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/13053128-1834882202797629.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/13053128-1834882202797629.jpg',
      },
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/13053128-1444882202841288.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/13053128-1444882202841288.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/13053128-1444882202841288.jpg',
      },
    ],
    defaultVariant: {
      inStock: true,
      __typename: 'ProductVariant',
    },
    inWishlist: false,
    options: sharedProductOptions,
    variants: sharedColourVariants,
    marketedSpecialOffer: sharedMarketedSpecialOffer,
  },
  {
    __typename: 'Product',
    sku: 13112951,
    url:
      '/sports-clothing/limited-edition-mp-men-s-tempo-ultra-seamless-short-sleeve-t-shirt-black/13112951.html',
    title:
      "Limited Edition MP Men's Tempo Ultra Seamless Short Sleeve T-Shirt - Black",
    reviews: {
      __typename: 'ProductReviews',
      total: 0,
      averageScore: 0,
    },
    images: [
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/13112951-1964944366022758.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/13112951-1964944366022758.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/13112951-1964944366022758.jpg',
      },
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/13112951-1704944366061701.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/13112951-1704944366061701.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/13112951-1704944366061701.jpg',
      },
    ],
    defaultVariant: {
      inStock: true,
      __typename: 'ProductVariant',
    },
    inWishlist: false,
    options: sharedProductOptions,
    variants: sharedColourVariants,
    marketedSpecialOffer: sharedMarketedSpecialOffer,
  },
  {
    __typename: 'Product',
    sku: 12761751,
    url:
      '/sports-t-shirts/mp-men-s-adapt-camo-short-sleeve-t-shirt-blue-camo/12761751.html',
    title: "MP Men's Adapt Camo Short Sleeve T-Shirt - Blue Camo",
    reviews: {
      __typename: 'ProductReviews',
      total: 3,
      averageScore: 5,
    },
    images: [
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12761751-1434877503261395.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12761751-1434877503261395.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12761751-1434877503261395.jpg',
      },
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12761751-1634877503321413.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12761751-1634877503321413.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12761751-1634877503321413.jpg',
      },
    ],
    defaultVariant: {
      inStock: true,
      __typename: 'ProductVariant',
    },
    inWishlist: false,
    options: sharedProductOptions,
    variants: sharedColourVariants,
    marketedSpecialOffer: sharedMarketedSpecialOffer,
  },
  {
    __typename: 'Product',
    sku: 12761760,
    url:
      '/sports-t-shirts/mp-men-s-adapt-camo-short-sleeve-t-shirt-red-camo/12761760.html',
    title: "MP Men's Adapt Camo Short Sleeve T-Shirt- Red Camo",
    reviews: {
      __typename: 'ProductReviews',
      total: 0,
      averageScore: 0,
    },
    images: [
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12761760-1734877503533057.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12761760-1734877503533057.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12761760-1734877503533057.jpg',
      },
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12761760-3474877503594272.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12761760-3474877503594272.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12761760-3474877503594272.jpg',
      },
    ],
    defaultVariant: {
      inStock: true,
      __typename: 'ProductVariant',
    },
    inWishlist: false,
    options: sharedProductOptions,
    variants: sharedColourVariants,
    marketedSpecialOffer: sharedMarketedSpecialOffer,
  },
  {
    __typename: 'Product',
    sku: 12768291,
    url:
      '/sports-t-shirts/mp-men-s-adapt-grit-graphic-t-shirt-merlot-marl/12768291.html',
    title: "MP Men's Adapt Grit Graphic T-Shirt - Merlot Marl",
    reviews: {
      __typename: 'ProductReviews',
      total: 3,
      averageScore: 5,
    },
    images: [
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12768291-2194877509778778.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12768291-2194877509778778.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12768291-2194877509778778.jpg',
      },
      {
        __typename: 'ProductImage',
        thumbnail:
          'https://s1.thcdn.com/productimg/70/70/12768291-1564877509835478.jpg',
        largeProduct:
          'https://s1.thcdn.com/productimg/300/300/12768291-1564877509835478.jpg',
        zoom:
          'https://s1.thcdn.com/productimg/960/960/12768291-1564877509835478.jpg',
      },
    ],
    defaultVariant: {
      inStock: true,
      __typename: 'ProductVariant',
    },
    inWishlist: false,
    options: sharedProductOptions,
    variants: sharedColourVariants,
    marketedSpecialOffer: sharedMarketedSpecialOffer,
  },
]

export const productWithClickAndCollect = {
  __typename: 'Product',
  sku: 13111287,
  url:
    '/sports-clothing/mp-men-s-velocity-short-sleeve-t-shirt-black/13111287.html',
  title: "MP Men's Velocity Short Sleeve T-Shirt - Black",
  reviews: {
    __typename: 'ProductReviews',
    total: 0,
    averageScore: 0,
  },
  images: [
    {
      __typename: 'ProductImage',
      thumbnail:
        'https://s1.thcdn.com/productimg/70/70/13111287-1224909887458763.jpg',
      largeProduct:
        'https://s1.thcdn.com/productimg/300/300/13111287-1224909887458763.jpg',
      zoom:
        'https://s1.thcdn.com/productimg/960/960/13111287-1224909887458763.jpg',
    },
    {
      __typename: 'ProductImage',
      thumbnail:
        'https://s1.thcdn.com/productimg/70/70/13111287-1964909887503022.jpg',
      largeProduct:
        'https://s1.thcdn.com/productimg/300/300/13111287-1964909887503022.jpg',
      zoom:
        'https://s1.thcdn.com/productimg/960/960/13111287-1964909887503022.jpg',
    },
  ],
  defaultVariant: {
    inStock: true,
    eligibleForFulfilmentMethods: ['HOME_DELIVERY'],
    __typename: 'ProductVariant',
  },
  inWishlist: false,
  options: sharedProductOptions,
  variants: sharedColourVariants,
  marketedSpecialOffer: sharedMarketedSpecialOffer,
}
